$.fn.reverse = [].reverse;

// used for qui<b></b>ck order page and quick order pad

bq.quickOrder = function(element, options) {
  this.options   = options;
  this.$element  = $(element);

};

bq.quickOrder.DEFAULTS = {
  skuInput: 'sku-quick-order',
  qtyInput: 'qty-quick-order',
  btn: 'qo-add',
  btnClearCart: 'qo-clear',
  clearLine: '.clear-line-link',
  ajaxUrl: '',
  ajaxParams: {},
  extended: false,
  btnAdd: false,
  btnClear: false,
  detailClassPrefix: 'item-',
  validateForms: true,
  //AB
  offersTemplate : '<a href="%url%" class="product-other-offers" target="_blank">%message%</a>',
  pdpUrl: 'catalog/product/view/id/',
  baseUrl: bq.global.baseUrl,
  msgSeeMoreOffers: bq.messages.ab.seeMoreOffers,
  msgSeeMoreOffersNum: bq.messages.ab.seeMoreOffersNum,
};

bq.quickOrder.prototype = {
  init: function() {
    bq.debug.log("Quick Order : init()", this.$element);
    var form = this.$element.parents('form').first();
    if(this.options.ajaxUrl.length <= 0) { //if no ajax url found, just exit with error
      bq.debug.error("Quick Order : No data-ajax-url found", this);
      return;
    }

    var initDataElement = jQuery('#init_quick_order_data');
    if (initDataElement.data()) {
        this.validateSkuCollection(initDataElement.data('row_id_suffix'), initDataElement.data('init_data'), {thiz: this});
    }

    //set event for key up
    this.$element.on('focusout', '.'+this.options.skuInput, {thiz: this}, this.skuChange);
    this.$element.on('bq.refresh', '.'+this.options.skuInput, {thiz: this}, this.skuChange);
    this.$element.on('focusout', '.qo-qty', {thiz: this}, this.qtyChange);
    this.$element.on('change', 'input.amazon-product', {thiz: this}, this.amazonQtyChange);

    if(this.options.btnAdd) { //add row button
      $('#'+this.options.btnAdd).on('click', {thiz: this}, this.addRow);
    }

    //reset event on form
    form.on('reset', {thiz: this}, function(e) {
      e.preventDefault(); // Prevent default reset behavior
      var $this = e.data.thiz;
      var tmp = $('.'+$this.options.skuInput+', .'+$this.options.qtyInput, $this.$element);
      tmp.each(function(){
          $(this).val('');
          $this.clearStatus(this);
      });
      tmp.promise().done(function(){
        $this.throwEventClear();
      });
      $('.bq-alert').remove();
    });

    if(this.options.btnClear) {
        var $this = this;
        $('#'+this.options.btnClear).on('click', function(){
            $this.$element.closest('form')[0].reset();
            $this.$element.closest('form').find('.item-name').html('');
            $this.$element.closest('form').find('.addition-info-container, .line-items-toggle, .col-toggle').html('');
            $this.$element.closest('form').find('input:hidden').val('').removeAttr('required');
            $this.$element.closest('form').find('.qo-sku').val('').removeAttr('required');
            $this.$element.closest('form').find('.qo-qty').val('').removeAttr('required');
        });
    }

    $('#large_order').on('click', {thiz: this}, this.saveFormData );

    $(document).on('click', '.remove-row', function() {
        $(this).closest('tr').find('.qo-sku').val('').blur();
    });

    $(this.options.clearLine + ' a', this.$element).on('click', {thiz: this}, this.catchClearLineEvent);

    $(this.options.clearLine).hide();

    //submit button
    $('#'+this.options.btn).on('click', {thiz: this}, this.validateForm);

    this.$element.on('bq.quickOrder.loadStart', function(){
      $('#'+this.options.btn).prop('disabled', true);
      $('#'+this.options.btnClearCart).prop('disabled', true);
    }.bind(this));

    this.$element.on('bq.quickOrder.loadEnd',  function(){
      $('#'+this.options.btn).prop('disabled', false);
      $('#'+this.options.btnClearCart).prop('disabled', false);
    }.bind(this));
  },

  skuChange: function(e) {
    var $this = e.data.thiz;
    var $input = $(this);
    var sku = $input.val().trim();
    var lastSku = $input.data('lastSku');

    if($input.data('validateSku') === false) { return; }

    // Leaving an already-validated SKU unchanged shouldn't re-validate it, that throws away the
    // chosen supplier / configured options. Errors are re-checked so a failed lookup can be retried.
    var $status = $input.parent();
    if (e.type === 'focusout' && sku.length >= 1 && sku === lastSku
        && $status.hasClass('has-feedback') && !$status.hasClass('has-error')) {
      return;
    }

    $this.throwEventLoadStart();

    if(sku.length >= 1) {
      bq.debug.log("Quick Order : skuChange : running ajax");

      $this.clearStatus(this);
      $this.setLoading(this);

      var tmpBefore = $($input.closest('.form-set')).find('input[name^="prod_service"]:checked').val();

      $input.data('lastSku', sku); //save what is running so we dont keep running
      var quantity = $('.' + $this.options.qtyInput, $input.parents('tr'));

      var ajaxParams = $this.options.ajaxParams;
      if (!ajaxParams) {
        ajaxParams = {};
      }
      ajaxParams.sku = sku;

      ajaxParams.qty = 1;
      if (quantity) {
          ajaxParams.qty = quantity.val();
      }

      if ($input.data('add-available-quote') === 1) {
          ajaxParams.add_available_quote_status = 1
      }

      if (ajaxParams.refresh_by_id) {
          var id = $('.qo-id', $input.parents('tr'));
          ajaxParams.id = id.val();
      }

      $.getJSON( $this.options.ajaxUrl, ajaxParams)
        .done(function( json ) {
            bq.debug.log("Quick Order : skuChange : ajax done", json);
            // A newer lookup was started for this row (or it was cleared) while this one was in
            // flight, drop the stale response so it can't overwrite the newer result
            if ($input.data('lastSku') !== sku) {
                return;
            }
            var nativeQuantity = quantity.parents('table').find("input.qty-copy");
            var qtyVal = quantity.val();
            var tmpAfter = $($input.closest('.form-set')).find('input[name^="prod_service"]:checked').val();
            if (qtyVal <= 0 || qtyVal === '' || isNaN(qtyVal)) {
                qtyVal = 1;
            }
            if (tmpBefore != tmpAfter) {
                return;
            }

            if (json.qty_increment) {
              quantity.attr('data-validate-qtyincrement', [json.min_sale_qty || 1, json.max_sale_qty, json.qty_increment]);
              quantity.removeAttr('data-validate-type');
              quantity.removeAttr('min');
              quantity.removeAttr('max');
            } else {
              if (json.is_qty_decimal) {
                quantity.attr('data-validate-type', 'number');
                quantity.attr('data-validate-qty-input', 'true');

                quantity.attr('min', '0');
                if (nativeQuantity.length == 1) {
                  nativeQuantity.attr('data-validate-type', 'number');
                  nativeQuantity.attr('data-validate-qty-input', 'true');
                  nativeQuantity.attr('min', '0');
                }
              } else {
                quantity.attr('data-validate-type', 'integer');
                quantity.attr('data-validate-qty-input', 'true');
                quantity.attr('min', '1');
                if (nativeQuantity.length == 1) {
                  nativeQuantity.attr('data-validate-type', 'integer');
                  nativeQuantity.attr('data-validate-qty-input', 'true');
                  nativeQuantity.attr('min', '1');
                }
              }
            }

            quantity.removeClass('amazon-product');
            if (json.productCollection) {
                quantity.val(qtyVal);
                $this.skuDuplicates($input, json);
            } else if (json.isAvailable && json.hasOptions) {
                quantity.val(qtyVal);
                $this.skuHasOptions($input, json);
                if ($this.options.extended) {
                    $('.' + $this.options.detailClassPrefix + 'name', $($input.parents('tr')[0])).html(bq.messages.global.skuMultiple);
                    $this.updateDetails($input, json);
                } else {
                    $('.qo-id', $input.parent()).val(json.id);
                }
            } else if (json.isAvailable) {
                if (json.is_amazon_product) {
                    quantity.addClass('amazon-product');
                }

                quantity.val(qtyVal);
                $this.skuValid($input, json);
                if (qtyVal <= 0 || qtyVal === '' || isNaN(qtyVal)) {
                    quantity.val('1');
                }
                if ($this.options.extended) {
                    $this.updateDetails($input, json);
                } else {
                    $('.qo-id', $input.parent()).val(json.id);
                }
            } else {
                $this.skuInvalid($input, json);
            }
            $this.throwEventLoadEnd();
        })
        .fail(function( jqxhr, textStatus, error ) {
          if ($input.data('lastSku') !== sku) {
            return;
          }
          var err = textStatus + ", " + error;
          bq.debug.error("Quick Order : skuChange : ajax error : " + err, this);
          $this.setError($input, bq.messages.global.skuError);
          $this.throwEventLoadEnd();
      });

    } else {
      if(sku.length === 0 && sku != lastSku) {
        $this.catchClearLineEvent(e);
      }
      bq.debug.log("Quick Order : skuChange : empty");
      $this.throwEventLoadEnd();
    }
  },

  updateDetails: function(input, json, clear) {
    input = $(input);
    var $this = this,
        $parent = input.closest('tr'),
        $container = input.closest('td'),
        $table = input.closest('table'),
        $qtyInput = $('.'+$this.options.qtyInput, $parent);

    $parent.attr('data-mobile', ($parent.data('mobile') === true) || (input.val().length > 0));

    if (clear) {
      $("[class*='"+this.options.detailClassPrefix+"']", $parent).not('.item-unspsc').not('.toggle-item-link').each(function(item) {
        $(this).html('');
      });
        var dotdotdot = $('.ellipsis', $parent).data('dotdotdot');
      if (dotdotdot) {
	      $('.ellipsis', $parent).dotdotdot('destroy');
      }
      $container.find('.item-unspsc').filter(':input').val('');
      $(this.options.clearLine, $parent).hide();
      $('.hidden-label', $parent).addClass('hidden');
      $('.back-ordered-warning', $parent).remove();
      return;
    }

    $(this.options.clearLine, $parent).show();
    $.each(json, function(i, item) {

      if (i === 'offers_count') {
          i = 'offers';
          item = $this.getOffersHtml(item, json.id);
      }

      var tmp = $('.'+$this.options.detailClassPrefix+i, $parent);
      if (!tmp.length) {
          // In case when target and sku located in different containers (create quote page)
          tmp = $('.'+$this.options.detailClassPrefix+i, $parent.parent());
      }
        if(i === 'price') {
          tmp.data('price', item);

          if (json.tier_prices) {
            tmp.data('tier_prices', json.tier_prices);
          } else {
            tmp.data('tier_prices', null);
          }

          if (json.price_value) {
            tmp.data('price_value', json.price_value);
          } else {
            tmp.data('price_value', null);
          }

            if (json.price_base) {
                tmp.data('price_base', json.price_base);
            } else {
                tmp.data('price_base', null);
            }

          if (json.extra_price) {
            tmp.data('extra_price', json.extra_price);
          } else {
            tmp.data('extra_price', null);
          }

          if (json.price_min) {
            tmp.data('price_min', json.price_min);
          } else {
            tmp.data('price_min', null);
          }

          if (json.price_max) {
            tmp.data('price_max', json.price_max);
          } else {
            tmp.data('price_max', null);
          }

          if (json.hasOptions) {
            tmp.data('hasOptions', json.hasOptions);
          } else {
            tmp.data('hasOptions', null);
          }

          if (json.price_format) {
            tmp.data('price_format', json.price_format);
          } else {
            tmp.data('price_format', null);
          }

          if (tmp.is('span')) {
            var priceInput = tmp.parent().find('input');
            if (priceInput) {
              priceInput.val(accounting.unformat(item));
            }
          }
        }

        if (['name', 'manufacturer_name', 'manufacturer_part_number'].indexOf(i) > -1) {
            $table.find('input[name*="[' + i + ']"]').val(item);
        }

        if(i === 'image') {
          var url = item;
          item = $('<img/>').attr({
            'data-srcset': url,
            'class': 'img-responsive',
            'data-bq': 'image-load',
            'width': '55',
            'height': '55',
            'data-supplier-id': json.supplier_id,
            'data-image-type': 'product',
            'title': json.name,
            'alt': json.name
          });
        }

        if(i === 'id') {
          $('.qo-id', $parent).val(item);
        }

        if (i === 'min_sale_qty') {
            var qtyVal = $qtyInput.val();
            if (qtyVal === '' || isNaN(qtyVal) || qtyVal < item) {
                $qtyInput.val(item);
            }

            if (!json.qty_increment) {
                $qtyInput.attr('min', item);
            }
        }

        if(i === 'max_sale_qty' && !json.qty_increment) {
          $qtyInput.attr('max', item);
        }

        if (i === 'is_back_ordered' && item) {
          $('.qo-id', $parent).parent().append($('<div class="item-warning text-warning back-ordered-warning"><span class="fa fa-exclamation-triangle">&nbsp;</span>' + bq.messages.global.currentlyBackOrdered + '</div>'));
        }

        if (i === 'is_pre_order' && item) {
          $('.qo-id', $parent).parent().append($('<div class="item-warning text-info back-ordered-warning"><span class="fa fa-exclamation-triangle">&nbsp;</span>' + bq.messages.global.preOrder + '</div>'));
        }

        if (i === 'is_qty_decimal') {
          if (item) {
              $qtyInput.attr('data-validate-type', 'number');
          } else {
              var qtyValue = Math.round(parseFloat($qtyInput.val()));
              $qtyInput.val(qtyValue);
          }
        }

        if (i === 'unspsc') {
            $table.find('input[name*="[unspsc]"]')
                .val(item)
                .select2('data', {id: item, text: item, disabled: false});
        }

        if (i === 'name') {
            $table.find('input[name*="[caption]"]').val(item);
        }

        if (i === 'unit_of_measure') {
            $table.find('select[name*="[unit_of_measure]"]').val(item).trigger('change');
        }

        if (i === 'item_type') {
            $table.find('select[name*="[item_type]"]').val(item).trigger('change');
        }

        if(tmp.is(':input')) {
          tmp.val(accounting.unformat(item));
        } else {
          tmp.html(item);
        }

        if (i === 'price' || i === 'supplier') {
            tmp.parent().parent().find('.hidden-label').removeClass('hidden');
        }

        if (tmp.hasClass('ellipsis')) {
            tmp.dotdotdot({
                watch: true
            });
        }

        bq.global.imageLoader();
    });
  },

  addRow: function(e) {
    var $this = e.data.thiz;
    var skuInputs = $('.' + $this.options.skuInput, $this.$element);
    var rows = $(skuInputs).parents('tr').reverse();
    var rowsCount = rows.length;
    var row = $(skuInputs[0]).parents('tr')[0];
    var clearRows = rows.filter('[data-mobile="true"]').last().nextAll('[data-mobile]:hidden');

    if (clearRows.length > 0) {
        clearRows.eq(0).attr('data-mobile', true);
        return;
    }

    var newRow = $(row).clone(false);
    newRow.find('input').val('');
    newRow.find('.col-toggle').html('');
    newRow.find('input').map(function() {
        var name = $(this).attr('name');
        var re = /items\[(.*?)_(.*?)\]/gmi;
        var m;
        while ((m = re.exec(name)) !== null) {
            if (m.index === re.lastIndex) {
                re.lastIndex++;
            }
            var newName = name.replace(m[1], rowsCount);
            $(this).attr('name', newName);
            $(this).attr('id', newName);
            $(this).siblings('label').attr('for', newName);
        }
    });

    $(row).parent().append(newRow);

    newRow.find('.qo-qty').removeAttr('data-validate-id');
    bq.global.parsley.destroy();
    bq.global.parsley.setup();

    $this.clearStatus($('.'+$this.options.skuInput, newRow));
    $(row).find('.fa-exclamation-triangle.text-error').parent().addClass('has-error has-feedback');
  },

  showModal: function(icon) {
    var modalContainerId = 'quick-order-modal-container';
    var $modalContainer = $('#' + modalContainerId);
    if (!$modalContainer.length) {
        $modalContainer = $('<div id="' + modalContainerId + '"></div>');
        $('body').append($modalContainer);
    }
    var $input = $(icon).closest('td').find('.' + this.options.skuInput);
    $modalContainer.html($input.data('jsonResponse').productModalHtml);
    var $modal = $modalContainer.children(':first');
    if (bq.global && this.options.validateForms) {
        bq.global.parsley.setup();

        $('[data-bq="product-price"]', $modal).each(function () {
          var $qo = $(this);
          $qo.productPrice($qo.data());
        });

    }
    var modalForm = $modal.find('form');
    modalForm.data('type', 'quick-order-bundle');

    if (modalForm.length && bq.helper.formToObject(modalForm).bundle_option) {
        bq.bundle.init(modalForm);
        $(modalForm).find('select[id^="bundle-option-input"]').trigger('bq.global.select2Setup.after');
    }
    $modal.data('input', $input);

    $modal.modal('toggle');

    $modal.on('click', '.duplicate-sku-action', {thiz: this}, this.catchEventClickChoose);
    $modal.on('click', '.product-options-action', {thiz: this}, this.catchEventClickSaveOptions);

    $modal.on('click', function(e){ e.stopImmediatePropagation(); });

    $modal.on('click', '[data-toggle=collapse]', function(e){
        bq.helper.throwEvent('click.bs.collapse.data-api', $(this));
    });

	  if($('.configure-option.required').length > 0) {
		  $('[data-required=true]').each(function() {
			  $(this).attr('required', 'required');
		  });
	  }

    bq.global.dateTimePickerSetup();

  },

  skuValid: function(input, json) {
    var text = false,
        $this = this;
    if(json.hasOptions) {
      //text='Item has configuration, you will be asked to customize once added to your cart.';

      $.getJSON( this.options.ajaxUrl, { id: json.id, qty: this.options.qtyInput } )
        .done(function( optionsJson ) {
          // the lookup by id doesn't return the supplier, keep the one from the chosen item
          optionsJson.supplier = optionsJson.supplier || json.supplier;
          var extended = $this.options.extended;
          $this.options.extended = false;
          $this.skuHasOptions(input, optionsJson);
          $this.options.extended = extended;
        })
        .fail(function( jqxhr, textStatus, error ) {
          var err = textStatus + ", " + error;
          $this.setWarning(input, bq.messages.global.skuError);
        });
    } else if (json.info_messages) {
        this.setInfo(input, this.processInfoMessages(json.info_messages));
    } else if (json.linked_sku_message) {
        this.setInfo(input, json.linked_sku_message);
    } else {
      this.setSuccess(input, text);
    }

  },

  processInfoMessages(infoMessages) {
    var parts = [];
      $.each(infoMessages, function(i, item) {
          if (item['message_code'] && bq.messages.global[item['message_code']]) {
              parts.push(bq.messages.global[item['message_code']].replace(/{(\d+)}/g, function(match, number) {
                    return typeof item['args'][number] != 'undefined'
                      ? item['args'][number]
                      : match
                      ;
                    })
              );
          }
      });
      return parts.join(",</br>");
  },

  skuInvalid: function(input, json) {
      var text = bq.messages.global.skuInvalid;
      if (json.message) {
          text = json.message;
      } else if (json.error_messages) {
          text = json.error_messages.join(', ');
      }
      this.setError(input, text);
      var input = $(input);
      var $icon = input.closest("td").find('.form-control-feedback');
      $icon.on('click', {thiz: this}, this.catchEventClickInvalid);
      var qty = input.closest('td').next('td').find('.qo-qty');
      qty.focus().val('').blur();
  },

  skuDuplicates: function(input, json) {

    this.setWarning(input, bq.messages.global.skuMultiple);

    input.data('jsonResponse', json);
    var $icon = $(input).closest("td").find('.form-control-feedback');
    $icon.on('click', {thiz: this}, this.catchEventClickDuplicate);

    // New UI themes: a "Select" action replaces the qty pill until an item is chosen
    if (this.isNewTheme()) {
      this.addFeedbackAction(input, bq.messages.global.skuMultipleSelect);
    }
  },

  skuHasOptions: function(input, json) {
    this.setWarning(input, bq.messages.global.skuConfig);
    input.data('jsonResponse', json);
    var $icon = $(input).closest("td").find('.form-control-feedback');
    $icon.on('click', {thiz: this}, this.catchEventClickOptions);

    // New UI themes: a "Configure" action replaces the qty pill until options are set
    if (this.isNewTheme()) {
      this.addFeedbackAction(input, bq.messages.global.skuConfigure);
    }
  },

  isNewTheme: function() {
    return $('body').hasClass('theme-new') && this.$element.hasClass('qo-table');
  },

  // Swaps the qty pill for a button that opens the same modal as clicking the SKU's
  // warning icon (the icon alone isn't obvious enough); clearStatus() swaps it back
  addFeedbackAction: function(input, label) {
    var $this = this;
    var $qtyTd = $(input).closest('td').next('td').addClass('qo-qty-action');
    var $action = $('<button type="button" class="btn qo-feedback-action"></button>')
      .text(label)
      .append(' <span class="fa fa-angle-right"></span>')
      .on('click', function() { $this.showModal(input); });
    $qtyTd.append($action);
  },

  setError: function(input, text) {
    this.setStatus(input, 'error', text);
  },

  setSuccess: function(input, text) {
    var $success = 'success';
    if(text) { $success = 'success-warning'; }

    this.setStatus(input, $success, text);
  },

  setWarning: function(input, text) {
    this.setStatus(input, 'warning', text);
  },

  setInfo: function(input, text) {
   this.setStatus(input, 'info-warning', text);
  },

  setLoading: function(input) {
    this.setStatus(input, 'loading');
  },

  setStatus: function(input, type, text) {
    this.clearStatus(input);

    var $parent = $(input).parent("td");

    if($parent.length < 1) { $parent = $(input).closest(".form-group"); }


    var classes = '';
    var iconClasses = '';

    switch(type) {
      case "warning":
        classes = 'has-warning has-feedback';
        iconClasses = 'fa fa-exclamation-triangle text-warning form-control-feedback';
        break;
      case "error":
        classes = 'has-error has-feedback';
        iconClasses = 'fa fa-exclamation-triangle text-error form-control-feedback';
        break;
      case "loading":
        classes = 'has-feedback';
        iconClasses = 'fa fa-refresh fa-spin text-muted form-control-feedback';
        break;
      case "success-warning":
        classes = 'has-success has-feedback';
        iconClasses = 'fa fa-exclamation-triangle text-warning form-control-feedback';
        break;
      case "info-warning":
        classes = 'has-success has-feedback';
        iconClasses = 'fa text-info fa-info-circle form-control-feedback';
        break;
      default:
        classes = 'has-success has-feedback';
        iconClasses = 'fa fa-check text-success form-control-feedback';
        break;
    }

    var $icon = $('<i></i>').addClass(iconClasses);
    $parent.append($icon).addClass(classes);

    if(text) {
      var params = {
        title: text
      };
      if (type === "info-warning") {
        params.html = true;
      }
      $icon.tooltip(params);
    }

  },

  clearStatus: function(input) {
    var $parent = $(input).parent();
    $parent.removeClass('has-success has-feedback has-error has-warning has-info');
    $('.form-control-feedback', $parent).tooltip('destroy').remove();
    $parent.closest('tr').find('.qo-feedback-action').remove();
    $parent.closest('tr').find('.qo-qty-action').removeClass('qo-qty-action');
    $(this.options.clearLine, $parent.parent()).hide();
    if(this.options.extended) {
      this.updateDetails(input, {}, true);
    }
  },

  validateForm: function(e) {
    var $this = e.data.thiz;

    if($('.has-feedback', $this.$element).length === 0){
      $('.'+$this.options.skuInput, $this.$element).first().prop('required', true);
    }

    var els = $('.has-warning, .has-error', $this.$element);

    if(els.length >= 1) {
      var tp =  $('.form-control-feedback',els[0]).tooltip('show');

      e.stopPropagation();
      e.preventDefault();
    } else {
        var $form = $('#quote-new').length > 0 ? $('#quote-new').find('form') : $this.$element.closest('form');
        var alreadyValidated = $form.data('alreadyValidated');
        var isValidated = false;
        if (!alreadyValidated) {
            isValidated = $form.parsley().validate();
        }

        if(isValidated){
            $form.data('alreadyValidated', true);
            //disable add to cart button
            $('#'+$this.options.btn).prop('disabled', true).addClass('disabled');

            $form.formCompress();
            $form.submit();
        }

    }
  },

  selectDuplicateItem: function(modal) {

    var $input = modal.find('input:checked');

    if(typeof($input) === 'object') {

      var val = $input.val();
      var $skuInput = modal.data('input');
      var $parent = $skuInput.parent();
      var json = $skuInput.data('jsonResponse');


      json = json.productCollection['product_'+val];

      this.skuValid($skuInput, json);

      modal.modal('toggle');

      $('.qo-id', $parent).val(json.id);
      $skuInput.val(json.sku);
      $skuInput.data('modalId', false);
      $skuInput.data('jsonResponse', false);
      $skuInput.data('lastSku', json.sku);

      if(this.options.extended) {
        this.updateDetails($skuInput, json);
      }

      this.throwEventLoadEnd();
    }
  },

  saveProductOptions: function(modal) {
    var $skuInput = modal.data('input');
    var $parent = $skuInput.parent();
    var json = $skuInput.data('jsonResponse');
    var form = modal.find('form');
    form.parsley();
    var tmpForm = bq.helper.formToObject(form);
    var tmpName = $skuInput.attr('name').replace('[sku]','');
    var elNameOption =''+tmpName+'[options]';
    var elNameBundleOption =''+tmpName+'[bundle_option]';
    var elNameBundleOptionQty=''+tmpName+'[bundle_option_qty]';


    if(form.data('Parsley') && !form.parsley().validate()) {
      return false;
    }


    var oldPrice = json.price;
    var newPrice = modal.find('.summary-price').text();
    if (oldPrice.indexOf(' - ') === -1 && accounting.unformat(oldPrice)) {
        json.extra_price = (accounting.unformat(newPrice) - accounting.unformat(oldPrice));
    }
    json.price = newPrice;
    json.hasOptions = false;

    this.skuValid($skuInput, json);
    //simple product
    if(tmpForm.options){
      bq.helper.itemToForm($parent, tmpForm.options, elNameOption);
    }
    //bundle product
    if(tmpForm.bundle_option){
      bq.helper.itemToForm($parent, tmpForm.bundle_option, elNameBundleOption);
    }
    if(tmpForm.bundle_option){
      bq.helper.itemToForm($parent, tmpForm.bundle_option_qty, elNameBundleOptionQty);
    }

    modal.modal('toggle');

    if(this.options.extended) {
      this.updateDetails($skuInput, json);
    }

    $skuInput.val(json.sku);
    $skuInput.data('modalId', false);
    $skuInput.data('jsonResponse', false);
    $skuInput.data('lastSku', json.sku);

    this.throwEventLoadEnd();

  },

  catchEventClickSaveOptions: function(e) {
    var $this = e.data.thiz;
    var $el = $($(this).parents('.modal')[0]);
    e.stopImmediatePropagation();
    $this.saveProductOptions($el);
  },

  catchEventClickDuplicate: function(e) {
    var $this = e.data.thiz;
    $this.showModal(this);
  },

  catchEventClickOptions: function(e) {
    var $this = e.data.thiz;
    $this.showModal(this);
  },

  catchEventClickChoose: function(e) {
    var $this = e.data.thiz;
    var $el = $($(this).parents('.modal')[0]);
    e.stopImmediatePropagation();
    $this.selectDuplicateItem($el);
  },

  catchEventClickInvalid: function(e) {
    var $this = e.data.thiz;
    var input = $(this).closest('tr').find('.'+$this.options.skuInput);
    $(this).closest('tr').find('input').val('');
    input.data('lastSku', '');
    input.closest('td').next('td').find('.qo-qty').removeAttr('required');
    $this.clearStatus(input);
  },

  catchClearLineEvent: function(e) {
    bq.debug.log('quick order : clearing line');
    var $this = e.data.thiz;
    var $el = $(e.currentTarget).closest('tr');
    var input = $el.find('.'+$this.options.skuInput);
    var id = $el.find('.qo-id');
    var title = $el.find('.' + this.options.detailClassPrefix + 'title');
    var price = $el.find('.' + this.options.detailClassPrefix + 'price');
    var qty = $el.find('.'+$this.options.qtyInput);
    var $additionalInfoContainer = $el.next();

    input.data('lastSku', '').val('').removeAttr('required');
    id.val('');
    title.html('');
    price.html('');
    qty.val('');
    qty.parsley('reset');
    qty.siblings('.fa-exclamation-triangle').remove();
    qty.removeAttr('required').removeAttr('min').removeAttr('max');

    $this.clearStatus(input);
    $('.col-toggle', $el).html('');

    if ($additionalInfoContainer && $additionalInfoContainer.hasClass('addition-info-container')) {
        $additionalInfoContainer.remove();
    }
    if ($('.addition-info-container', $el.closest('table')).length === 0) {
        $('.line-items-toggle').html('');
    }
  },

  throwEventLoadStart: function() {
    bq.debug.log("quick order : event thrown [bq.quickOrder.loadStart]");
    this.$element.trigger('bq.quickOrder.loadStart', this);
  },

  throwEventLoadEnd: function() {
    bq.debug.log("quick order : event thrown [bq.quickOrder.loadEnd]");
    this.$element.trigger('bq.quickOrder.loadEnd', this);
  },

  throwEventClear: function() {
    bq.debug.log("quick order : event thrown [bq.quickOrder.clear]");
    this.$element.trigger('bq.quickOrder.clear', this);
  },

  saveFormData: function(e){
    var $this = e.data.thiz,
        form = $this.$element.parents('form').first();

    if(form.find('tbody tr:first-child td:first-child input[type="text"]').val() !== '') {
      e.preventDefault();
      form.attr('action', this.href);
      form.attr('method', 'post');
      form.submit();
    }
  },

  qtyChange: function(e) {
    var $qty = $(this),
        qty = $qty.val().trim(),
        $sku = $($qty.closest('tr').find('input.qo-sku'));

    var req = $sku.val() && !qty ? true : false;
    $qty.prop('required', req);

    var bundleQtyInp = $($qty.closest('tr')).find('input[name*=bundle_option_qty]');
    if (bundleQtyInp.length) {
      $(bundleQtyInp).each(function(){
        $(this).val(qty);
      });
    }
  },

  // amazon products are priced per quantity, so re-validate the sku when the qty changes
  amazonQtyChange: function(e) {
    var $this = e.data.thiz,
        $sku = $(this).closest('tr').find('.' + $this.options.skuInput);

    if ($sku.val().trim().length < 1) {
        return;
    }

    var hasError = $(this).closest('td').hasClass('has-error');
    if (hasError) {
        return;
    }

    $sku.trigger('bq.refresh');
  },

  validateSkuCollection: function (rowIdSuffix, skuCollection, data) {

      var $this = data.thiz;
      var i = 0;
      for (var item in skuCollection) {

          var id = '#items\\[' + i + rowIdSuffix + '\\]\\[sku\\]';
          var $input = jQuery(id);
          var json = skuCollection[item];

          if (json.productCollection) {
              $this.skuDuplicates($input, json);
          } else if (json.isAvailable && json.hasOptions) {
              $this.skuHasOptions($input, json);
              if ($this.options.extended) {
                  $('.' + $this.options.detailClassPrefix + 'name', $($input.parents('tr')[0])).html(bq.messages.global.skuMultiple);
                  $this.updateDetails($input, json);
              } else {
                  $('.qo-id', $input.parent()).val(json.id);
              }
          } else if (json.isAvailable) {
              $this.skuValid($input, json);
              if ($this.options.extended) {
                  $this.updateDetails($input, json);
              } else {
                  $('.qo-id', $input.parent()).val(json.id);
              }
          } else {
              $this.skuInvalid($input, json);
          }
          if (json.shipping) {
              $this.updateShipping($input, json, i);
          }
          if (json.accounting_short) {
              $this.updateAccounting($input, json, i);
          }
          i++;
      }
      // Init accounting popups
      bq.popupInit();
      if ($('.addition-info-container', $('.table')).length === 0) {
          $('.line-items-toggle').html('');
      }
      $this.throwEventLoadEnd();
  },

  updateShipping(input, json, i) {
      input = $(input);
      var $parent = input.closest('tr'),
          $additionalInfoContainer = $parent.siblings('#additional-info-container-' + i),
          $shippingContainer = $additionalInfoContainer.find('.additional-info-shipping');
      $shippingContainer.html(json.shipping_html);
  },

  updateAccounting(input, json, i) {
      input = $(input);
      var $parent = input.closest('tr'),
          $additionalInfoContainer = $parent.siblings('#additional-info-container-' + i),
          $accountingShortContainer = $additionalInfoContainer.find('.additional-info-accounting-short'),
          $accountingDetailsContainer = $additionalInfoContainer.find('.additional-info-accounting-details');
      $accountingShortContainer.html(json.accounting_short);
      $accountingDetailsContainer.html(json.accounting_details);
  },

  getOffersHtml: function(num, id) {
    num = !!num ? num : 0;
    var msg = this.options.msgSeeMoreOffers;
    if (num) {
      msg = this.options.msgSeeMoreOffersNum.replace('%s', num);
    }

    return this.options.offersTemplate
      .replace('%url%', this.getSeeMoreOffersUrl(id))
      .replace('%message%', msg)
  },

  getSeeMoreOffersUrl: function(id) {
    return this.options.baseUrl + this.options.pdpUrl + id + '/offers/1';
  },
};

// QUICK ORDER PLUGIN DEFINITION
// =======================

var bqQuickOrderold = $.fn.bqQuickOrder;

$.fn.bqQuickOrder = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.quickOrder');
    var options = $.extend({}, bq.quickOrder.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.quickOrder', (data = new bq.quickOrder(this, options))); }
    data.init();
  });
};

$.fn.bqQuickOrder.Constructor = bq.quickOrder;

// QUICK ORDER NO CONFLICT
// =================

$.fn.bqQuickOrder.noConflict = function () {
  $.fn.bqQuickOrder = bqQuickOrderold;
  return this;
};

// QUICK ORDER DATA-API
// ==============

bq.bqQuickOrderInit = function() {
  $('[data-bq="quick-order"]').each(function () {
    var el = $(this);
    if(el.data('bq.quickOrder')) { return; }
    el.bqQuickOrder(el.data());
  });
};

bq.init.push(bq.bqQuickOrderInit);
